import { observable, action, computed, makeObservable } from 'mobx';
import { DRIVER_BACKGROUND_STATUS, DRIVER_REGISTRATION_STATUS } from '../constants/status';

class DriverRegistrationStore {
  constructor(api) {
    makeObservable(this, {
      searchResult: observable,
      loadingRecords: observable,
      manualApproving: observable,
      requizing: observable,
      resendingBGURL: observable,
      query: observable,
      statusFilter: observable,
      stateFilter: observable,
      areaFilter: observable,
      setQuery: action,
      setRegion: action,
      setState: action,
      setStatus: action,
      setPage: action,
      searchFilter: computed,
      loadRecords: action,
      selectPage: action,
      sendBackgroundCheck: action,
      manualApprove: action,
      requiz: action,
      resendBackgroundRequestURL: action,
      unfrozening: observable,
      unfrozen: action,
      driverUnfreezening: observable,
      unfreezeDriver: action,
      coveredRegions: observable,
      getCoveredRegions: action,
    });

    this.api = api;

    this.page = 1;
    this.size = 15;
    // this.start = 0;
    // this.end = 0;
  }

  searchResult = null;
  loadingRecords = false;
  manualApproving = false;
  requizing = false;
  resendingBGURL = false;
  query = '';
  statusFilter = '';
  stateFilter = '';
  areaFilter = '';

  setQuery(q) {
    this.query = q;
    this.loadRecords();
  }

  setRegion(f) {
    this.areaFilter = f;
    this.loadRecords();
  }

  setState(f) {
    this.stateFilter = f;
    this.loadRecords();
  }

  setStatus(f) {
    this.statusFilter = f;
    this.loadRecords();
  }

  setPage(newPage) {
    this.page = newPage;
  }

  get searchFilter() {
    let filter = {};
    if (this.statusFilter) filter['status'] = this.statusFilter ? [this.statusFilter] : null;
    if (this.stateFilter) filter['state'] = this.stateFilter ? [this.stateFilter] : null;
    if (this.areaFilter) filter['areas'] = this.areaFilter ? [this.areaFilter] : null;
    return {
      page: this.page - 1,
      size: this.size,
      start: this.start,
      end: this.end,
      query: this.query ? this.query : null,
      filter: filter,
    };
  }

  // list records
  loadRecords() {
    this.loadingRecords = true;
    this.recordsRequested = Date.now();
    this.api
      .put(`/driver-registration`, this.searchFilter, { requested: this.recordsRequested })
      .then((response) => {
        if (response.config.requested !== this.recordsRequested) return;
        this.searchResult = this.processResults(response.data); // TODO: manipulate date into proper format
        this.loadingRecords = false;
      })
      .catch((e) => {
        this.loadingAssignments = false; // TODO: display error
      });
  }

  // FOR SEARCH TAB
  selectPage(page) {
    this.page = page;
    this.loadRecords();
  }

  sendBackgroundCheck(registration) {
    this.api.put(`/driver-registration/${registration.record.id}/background-check`).then((r) => {
      console.log(r.data);
      if (r.data === true) {
        registration.record.status = 'BACKGROUND_SENT';
      }
    });
    // TODO: handle result back
  }

  manualApprove(registration) {
    this.manualApproving = true;
    this.api.post(`/background_check/manually_approve`, { driver_id: registration.driver.id }).then((r) => {
      if (r.status === 200) {
        registration.driver.background_status = DRIVER_BACKGROUND_STATUS.MANUAL_APPROVED;
      }
      this.manualApproving = false;
    });
  }

  requiz(registration) {
    this.requizing = true;
    this.api.put(`/driver-registration/${registration.record.id}/requiz`).then((r) => {
      if (r.status === 200) {
        registration.record.status = DRIVER_REGISTRATION_STATUS.QUIZ_SENT;
      }
      this.requizing = false;
    });
  }

  resendBackgroundRequestURL(registration) {
    this.resendingBGURL = true;
    this.api.post(`/background_check/${registration.driver.id}/resend_background_request_url`).then((r) => {
      if (r.status === 200) {
        registration.driver.background_status = 'PENDING';
      }
      this.resendingBGURL = false;
    });
  }

  processResults(result) {
    result.registrations = result.registrations
      .filter((r) => r.driver)
      .map((r) => {
        if (r.quiz && r.quiz.questionnaire) {
          r.quiz.questionnaire = result.questionnaires[r.quiz.questionnaire.id];
        }
        return r;
      });
    result.total_pages = Math.ceil(result.count / result.size);
    result.page = result.page + 1;
    return result;
  }

  //Todo unfreeze()
  unfrozening = false;
  unfrozen(driverId = null, cb = () => {}) {
    if (!driverId) return;

    this.unfrozening = true;

    this.api.post(`/background_check/${driverId}/fcra_run`).then((res) => {
      if (res.ok || res.status == 204) {
        this.unfrozening = false;
      }

      if (cb) cb(res);
    });
  }

  //Todo unfreeze()
  driverUnfreezening = false;
  unfreezeDriver(driverId = null, regions = [], cb = () => {}) {
    if (!driverId) return;

    this.unfrozening = true;

    this.api.post(`/background_check/${driverId}/unfreeze`, regions).then((res) => {
      if (res.ok || res.status == 204) {
        this.driverUnfreezening = false;
      } else {
        if (res.data.message) {
          alert(res.data.message);
        }
      }

      if (cb) cb(res);
    });
  }

  //Todo getCoveredRegions
  coveredRegions = [];
  getCoveredRegions(cb) {
    this.api.get(`/background_check/covered_regions`).then((res) => {
      if (res.ok || res.status === 200) {
        this.coveredRegions = res.data;
      }

      if (cb) cb(res);
    });
  }
}

export default DriverRegistrationStore;
